import { render } from "./PagingBar.vue?vue&type=template&id=b1636798"
import script from "./PagingBar.vue?vue&type=script&lang=js"
export * from "./PagingBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/PagingBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1636798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1636798', __exports__)) {
    api.reload('b1636798', __exports__)
  }
  
  module.hot.accept("./PagingBar.vue?vue&type=template&id=b1636798", () => {
    api.rerender('b1636798', render)
  })

}


export default __exports__